$(document).ready(function() {
    // bulkalkaloids-1
    var swiper = new Swiper(".bulkalkaloids-1", {
      slidesPerView: 1,
      // centeredSlides: true,
      spaceBetween: 20,
      autoplay: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 65,
        },
      },
    });

    // mySwiper3
    var swiper = new Swiper(".mySwiper3", {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: false,
      direction: 'vertical',
      watchSlidesProgress: false,
    });
    // mySwiper2
    var swiper2 = new Swiper(".mySwiper2", {
      spaceBetween: 10,
      autoplay: true,
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
      thumbs: {
        swiper: swiper,
      },
    });

    // mySwiper5
    var swiper = new Swiper(".mySwiper5", {
      spaceBetween: 10,
      slidesPerView: 2,
      freeMode: false,
      direction: 'vertical',
      watchSlidesProgress: false,
    });
    // mySwiper4
    var swiper2 = new Swiper(".mySwiper4", {
      spaceBetween: 10,
      autoplay: true,
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
      thumbs: {
        swiper: swiper,
      },
    });

    var swiper = new Swiper(".swip-banners", {
        slidesPerView: 1,
        loop: true,
        // centeredSlides: true,
        spaceBetween: 20,
        autoplay: {
          delay: 7000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
  
    // navbar scroll
    $(document).scroll(function () {
      var scroll = $(this).scrollTop();
      var topDist = $(".sec2").position();
      if (scroll > topDist.top) {
          $('nav').addClass("navs-top");
          $('.scroll-tops').addClass("scroll-top");
      } else {
        $('nav').removeClass("navs-top");
        $('.scroll-tops').removeClass("scroll-top");
      }
    });

    $(document).scroll(function () {
      var scroll = $(this).scrollTop();
      if (scroll > 1200) {
          $('.scroll-tops').addClass("scroll-top");
      } else {
        $('.scroll-tops').removeClass("scroll-top");
      }
    });

    // top scroll
    $('#top').click(function () {
      $('body,html').animate({
          scrollTop: 0
      }, 2000);
    });
  })

const hideWatermark = () => {
  const wm = document.querySelector('.watermark-container-blockify');
  if (wm) {
    wm.remove(); // Or wm.style.display = 'none';
  }
};
const observer = new MutationObserver(hideWatermark);
observer.observe(document.body, { childList: true, subtree: true });
hideWatermark();